import { Box, Stack, TagsInput, Text } from "@mantine/core";
import { UserFilter } from "../models/UserFilter";

interface UserIdEmailFormProps {
  filters: UserFilter;
  setFilters: (newValue: UserFilter) => void;
  formInvalid: boolean;
  invalidFields: string[];
}
export const UserIdEmailForm = ({
  filters,
  setFilters,
  formInvalid,
  invalidFields
}: UserIdEmailFormProps) => {
  const handleUserIdsChange = (newValue: string[]) => {
      setFilters({ ...filters, userIds: newValue });
  };

  const handleEmailsChange = (newValue: string[]) => {
    setFilters({ ...filters, emails: newValue });
  };

  return (
    <Stack>
      <TagsInput
        label="User IDs"
        placeholder="Enter one or more User IDs"
        value={filters.userIds ?? undefined}
        onChange={handleUserIdsChange}
        disabled={(filters.emails?.length ?? 0) > 0}
        clearable
        data={[]}
      />
      <TagsInput
        label="Emails"
        placeholder="Enter one or more Emails"
        value={filters.emails ?? undefined}
        onChange={handleEmailsChange}
        disabled={(filters.userIds?.length ?? 0) > 0}
        clearable
        data={[]}
      />

      <Box h={30}>
        {formInvalid ? (
          <Text c="red" className="pushnotifications-invalid">
            Invalid fields: {invalidFields.join(", ")}
          </Text>
        ) : null}
      </Box>
    </Stack>
  );
};
